import {Button} from '@mui/material';
import {EmptySearchState} from 'presentation/components';
import {ChatRoomsEnum} from 'presentation/constants';
import {useCallChatRoom} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {Loading} from 'presentation/components/Loading/Loading';

const {specialtyNotFound} = translations['pt-br'].privateFlow.bookingFlow;
const {notFound, emptyDescription} = translations['pt-br'].commons;

const TelehealthSpecialtyNotFound = () => {
	const {callChatRoom, IS_LOADING: callChatRoomIsLoading} = useCallChatRoom();
	const handleCallChatRoom = () => {
		callChatRoom(ChatRoomsEnum.APP);
	};

	return (
		<EmptySearchState title={notFound} description={emptyDescription}>
			<Button
				onClick={handleCallChatRoom}
				size="large"
				disabled={callChatRoomIsLoading}
				endIcon={callChatRoomIsLoading ? <Loading size={16} color="inherit" /> : null}>
				{specialtyNotFound.secondaryButton}
			</Button>
		</EmptySearchState>
	);
};

export {TelehealthSpecialtyNotFound};
